module.exports = __webpack_public_path__ + "static/media/img_1.9a93b4e3.png";